export enum TwoFaMethods {
  Authenticator = 1,
  Sms
}
